/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action /*, runInAction*/ } from 'mobx';
//import fetch from '../fetch';

class CinematicsStore {
    @observable collection = {};
    @observable details = {};

    constructor() {
        this.baseUrl = '/api/cinematics';
    }

    @action.bound
    async detail({ _id = false } = {}) {}

    @action.bound
    async list({ hash, params } = {}) {}

    @action.bound
    async listMore({ hash } = {}) {}

    @action.bound
    async create({ item = {} } = {}) {}

    @action.bound
    async update({ item = {} } = {}) {}

    @action.bound
    async delete({ _id = false } = {}) {}
}

export default new CinematicsStore();
